<template>
  <PublicPopup ref="PopupRef" :closeable="false">
    <template #content>
      <div class="maintain-popup">
        <div class="images-box">
          <!-- <img src="" alt=""> -->
        </div>
        <div class="desc">
          <p>{{ t('home-ad-popup-index.maintenance.dearUsers') }}</p>
          <p>{{ t('home-ad-popup-index.maintenance.hello') }}</p>
          <p>
            {{
              t('home-ad-popup-index.maintenance.upgradeNotice', {
                version: maintenanceInfo.version,
              })
            }}
          </p>
          <p>
            {{
              t('home-ad-popup-index.maintenance.maintenanceWindow', {
                startTime: maintenanceInfo.startTime,
                endTime: maintenanceInfo.endTime,
                durationHours: maintenanceInfo.durationHours,
              })
            }}
          </p>
          <p>{{ t('home-ad-popup-index.maintenance.affectedServices') }}</p>
          <p>{{ t('home-ad-popup-index.maintenance.apology') }}</p>
        </div>
      </div>
    </template>
  </PublicPopup>
</template>

<script setup>
const { t } = useI18n()

/** 维护公告业务参数（版本与时间窗口由业务配置提供，不写死在翻译句子中） */
const maintenanceInfo = {
  version: 'V7.0',
  startTime: '04/01/2026 02:00:00',
  endTime: '04/01/2026 07:00:00',
  durationHours: 5,
}

const PopupRef = ref(null)
const open = () => {
  nextTick(() => {
    PopupRef.value.open()
  })
}

defineExpose({
  open,
})
</script>

<style lang="less" scoped>
.maintain-popup {
  height: 60vh;
  overflow-y: auto;

  .images-box {
    height: 200px;
  }

  .desc {
    font-size: 14px;
    color: var(--maintain-popup-content-text);
    line-height: 1.5;
  }
}
</style>
